import { useAlerts } from "components/Alerts/AlertProvider";
import { ConfirmDialog } from "components/ConfirmDialog";
import { useDeleteDocumentMutation } from "hooks/documents";

import { Row } from "./index";

type ConfirmDeleteDialogProps = {
  open: boolean;
  selectedDocument?: Row;
  onClose: () => void;
};

export const ConfirmDeleteDialog = ({
  open,
  selectedDocument,
  onClose,
}: ConfirmDeleteDialogProps) => {
  const alerts = useAlerts();

  const [deleteDocument, { loading }] = useDeleteDocumentMutation({
    refetchQueries: ["Documents"],
    onError(error) {
      alerts.error(`Could not delete document`, error);
    },
  });

  if (!selectedDocument) return <></>;

  const handleConfirm = async () => {
    await deleteDocument({
      variables: {
        id: selectedDocument.id,
        retainAsset: true,
      },
    });
    onClose();
  };

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
      loading={loading}
      header="Are you sure you want to delete this document?"
      resources={[
        {
          resourceType: "Document",
          resourceName: selectedDocument.title,
        },
      ]}
      info="This action is permanent. This document may be associated with other facilities, reports and chemicals."
    />
  );
};
